import React, { FC } from 'react';
import styled, { css } from 'styled-components';
// import media from '../../../constants/media';

const StyledWrapper = styled.div``;

const StyledControlWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	border: 1px solid ${({ theme }) => theme.colors.borderColor};
	color: ${({ theme }) => theme.colors.textDark};
	transition: border-color 150ms;
	user-select: none;
	max-width: 18rem;
	margin-left: 1rem;

	> div {
		padding: 0 0.75rem;
	}

	&:hover {
		border-color: ${({ theme }) => theme.colors.borderDark};
	}

	&:focus-within {
		border-color: ${({ theme }) => theme.colors.primary};
		box-shadow: 0 2px 6px ${({ theme }) => theme.colors.primary}33;
	}

	@media (min-width: 550px) {
		max-width: inherit;
		align-items: stretch;
		height: 5rem;
		position: inherit;
		top: inherit;
		left: inherit;
	}
`;

const StyledLabel = styled.div`
	width: 100%;
	padding: 0.5rem 2.2rem;
	border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};
	text-align: center;

	@media (min-width: 550px) {
		display: flex;
		align-items: center;
		width: auto;
		border-bottom: none;
		border-right: 1px solid ${({ theme }) => theme.colors.borderColor};
	}
`;

const StyledControl = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0.5rem 0;
	width: 33%;
	border-right: 1px solid ${({ theme }) => theme.colors.borderColor};
	text-align: center;

	@media (min-width: 550px) {
		width: auto;
		padding: 0.5rem 2.2rem;
	}

	&:last-child {
		border-right: none;
	}

	${({ disabled }) =>
		disabled &&
		css`
			pointer-events: none;

			> * {
				opacity: 0.2;
			}
		`};
`;

interface Props {
	id: string;
	onChange: any;
	name: string;
	label: string;
	value: number;
	disabled?: boolean;
	disabledText?: string;
}

const FormikNumberInput: FC<Props> = ({ id, onChange, name, label, value, disabled }) => {
	const val = value || 1;
	const onRaiseCount = () => {
		if (val < 99) {
			onChange(name, val + 1);
		}
	};

	const onLowerCount = () => {
		if (val > 1) {
			onChange(name, val - 1);
		}
	};

	return (
		<StyledWrapper id={id}>
			{!disabled && (
				<StyledControlWrapper>
					<StyledLabel>{label}</StyledLabel>
					<StyledControl disabled={disabled} onClick={onLowerCount}>
						<span>-</span>
					</StyledControl>
					<StyledControl>{val}</StyledControl>
					<StyledControl disabled={disabled} onClick={onRaiseCount}>
						<span>+</span>
					</StyledControl>
				</StyledControlWrapper>
			)}
		</StyledWrapper>
	);
};

export default FormikNumberInput;
